import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {DelAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class RevokeChatAccessCommand<T> extends DelAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number) {
    super(apiService, adapter, `${environment.chatApiUrl}/chat/access/${id}`);
  }
}
